<template>
    <div>
        <Layout>
            <div class="col-lg-12">
                <div class="card" style="min-height: 100vh">
                    <div v-if="isLoading" class="d-flex justify-content-center py-5">
                        <LoadingIcon />
                    </div>
                    <template v-else>
                        <template v-if="!isActiveBasicSetting && !isActiveMailSetting && !isActiveSaveTemporarilySetting">
                            <h3
                                v-b-tooltip.hover="`（${formDetail?.name}）`"
                                class="text-truncate"
                                style="position: absolute; top: -40px; left: 100px"
                            >
                                （{{ formDetail?.name }}）
                            </h3>
                            <div class="card-header">
                                <div class="title--screen" style="white-space: nowrap">
                                    {{ $t('managerForm.settingAdvanced.settingDetails') }}
                                </div>
                            </div>
                            <div class="card-body">
                                <div
                                    style="
                                        width: 100%;
                                        border: 1px solid #dbdbdb;
                                        border-radius: 4px;
                                        -webkit-border-radius: 4px;
                                        -moz-border-radius: 4px;
                                        box-shadow: 0px 2px 1px #c9c9c9;
                                        padding: 20px;
                                    "
                                >
                                    <!-- <div class="form-group row">
                                        <label
                                            class="col-sm-2 text-nowrap"
                                            style="min-width: 190px; color: #339162; cursor: pointer"
                                            @click="onOpenScreen('basic')"
                                        >
                                            {{ $t('managerForm.settingAdvanced.tabBasic') }}</label
                                        >
                                        <div class="col-sm-9"><span>基本情報、フォーム回答数等の情報を設定します </span></div>
                                    </div> -->
                                    <div class="form-group row">
                                        <label
                                            class="col-sm-2 text-nowrap"
                                            style="min-width: 190px; color: #339162; cursor: pointer"
                                            @click="onOpenScreen('mail')"
                                        >
                                            {{ $t('managerForm.settingAdvanced.tabMail') }}</label
                                        >
                                        <div class="col-sm-9"><span>管理者や回答された方への自動返信メールを設定します </span></div>
                                    </div>
                                    <!-- <div class="form-group row">
                                        <label
                                            class="col-sm-2 text-nowrap"
                                            style="min-width: 190px; color: #339162; cursor: pointer"
                                            @click="onOpenScreen('saveTemporarily')"
                                        >
                                            {{ $t('managerForm.settingAdvanced.tabSaveTemporarily') }}</label
                                        >
                                        <div class="col-sm-9"><span>フォームの一時保存の設定をします </span></div>
                                    </div> -->
                                </div>
                            </div>
                        </template>
                        <SettingEmail v-if="isActiveMailSetting" :detailForm="formDetail" />
                    </template>
                </div>
                <ModalListPreview
                    :formData="{
                        ...formDetail,
                        campaign_not_change: formDetail.campaign,
                        forms: formDetail.campaign_forms,
                        landing_pages: formDetail.campaign_lps
                    }"
                    :config.sync="configModalListPrv"
                />
            </div>
        </Layout>
        <Footer>
            <div style="display: grid; grid-template-columns: repeat(3, 1fr)">
                <div class="d-flex align-items-center" style="gap: 0.7rem">
                    <button type="submit" @click="onGotoList" class="btn btn-common-footer">
                        <i class="ri-list-check"></i>{{ $t('managerForm.settingPage.buttonType.goList') }}
                    </button>
                    <button type="submit " @click="handleGetDetail" class="btn btn-common btn-info" style="min-width: 76px">
                        <i class="ri-arrow-left-line"></i>{{ $t('btn.goToDetail') }}
                    </button>
                    <button
                        v-if="isActiveBasicSetting || isActiveMailSetting || isActiveSaveTemporarilySetting"
                        type="button"
                        class="btn btn-common btn-primary"
                        @click="onBackScreen"
                        style="min-width: 74px"
                    >
                        <i class="ri-arrow-left-line"></i>{{ $t('managerForm.settingAdvanced.btnBackScreen') }}
                    </button>
                </div>
                <div class="text-center">
                    <button type="button" class="btn btn btn-common-footer mr-2" @click="() => (configModalListPrv.model = true)">
                        <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                    </button>
                    <template v-if="isActiveBasicSetting || isActiveMailSetting || isActiveSaveTemporarilySetting">
                        <template v-if="isActiveMailSetting">
                            <button
                                v-if="checkPermission('form.setting_mail')"
                                type="button"
                                class="btn btn btn-common-footer"
                                @click="onGotoPageDomain"
                            >
                                <i class="ri-settings-3-line"></i>{{ $t('managerForm.settingAdvanced.goToPageDomain') }}
                            </button>
                        </template>
                    </template>
                </div>
            </div>
        </Footer>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import SettingEmail from './components/setting-email/main.vue';
import Footer from '@/components/Footer/main.vue';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { checkPermission } from '@/utils/handlers';
import { managerFormMethods } from '@/state/helpers';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'SettingAdvanced',
    components: { SettingEmail, Layout, Footer, ModalListPreview, LoadingIcon },
    data() {
        return {
            isLoading: true,
            isActiveBasicSetting: false,
            isActiveMailSetting: false,
            isActiveSaveTemporarilySetting: false,
            formDetail: {},
            configModalListPrv: {
                title: '',
                model: false,
                scrollable: true,
                hideFooter: false,
                centered: false,
                size: 'xl'
            }
        };
    },
    methods: {
        checkPermission,
        ...managerFormMethods,

        onBackScreen() {
            this.isActiveBasicSetting = false;
            this.isActiveMailSetting = false;
            this.isActiveSaveTemporarilySetting = false;
        },

        onGotoPageDomain() {
            this.$router.push({ path: '/manager-form/email' });
        },

        onOpenScreen(screen) {
            switch (screen) {
                case 'basic':
                    this.isActiveBasicSetting = true;
                    break;
                case 'mail':
                    this.isActiveMailSetting = true;
                    break;
                case 'saveTemporarily':
                    this.isActiveSaveTemporarilySetting = true;
                    break;
            }
        },
        onGotoList() {
            this.$router.push({ name: 'ManagerFormList' });
        },

        async getDetailFormAdvanced() {
            if (!this.$route?.query?.id) {
                this.isLoading = false;
                return;
            }
            try {
                const response = await this.getDetailManagerForm(this.$route.query.id);
                if (response.type === ID_PAGE_TYPE.C) {
                    this.$router.push({ name: 'errorPage' });
                    return;
                }
                this.formDetail = response;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        handleGetDetail() {
            this.$router.push({
                path: '/manager-form/view',
                query: {
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted() {
        this.getDetailFormAdvanced();
    }
};
</script>

<style lang="scss" scoped></style>
